import { SCAN_CONSTANTS } from '../constants/myDomainScanConstants';

const initialState = {
  loading: false,
  scanLoading: false,
  data: null,
  error: null,
  scans: [],
  oemScans: [],
  oemPagination: {},
  pagination: {},
};

const scanReducer = (state = initialState, action) => {
  switch (action.type) {
    case SCAN_CONSTANTS.FAST_DOMAIN_CHECK_REQUEST:
      return {
        ...state,
        scanLoading: true,
        error: null,
      };
    case SCAN_CONSTANTS.FAST_DOMAIN_CHECK_SUCCESS:
      return {
        ...state,
        scanLoading: false,
        data: action.payload,
        error: null,
      };
    case SCAN_CONSTANTS.FAST_DOMAIN_CHECK_FAILURE:
      return {
        ...state,
        scanLoading: false,
        error: action.payload,
      };
    case SCAN_CONSTANTS.GET_SCANS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SCAN_CONSTANTS.GET_SCANS_SUCCESS:
      return {
        ...state,
        loading: false,
        scans: action.payload.response || [],
        pagination: action.payload.pagination || {},
        error: null,
      };
    case SCAN_CONSTANTS.GET_SCANS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SCAN_CONSTANTS.GET_OEM_SCANS_REQUEST:
      return {
        ...state,
        loading: true,
        oemScans: [], // Clear old data when new request starts
        error: null,
      };
    case SCAN_CONSTANTS.GET_OEM_SCANS_SUCCESS:
      return {
        ...state,
        loading: false,
        oemScans: action.payload.response || [],
        oemPagination: action.payload.pagination || {},
        error: null,
      };
    case SCAN_CONSTANTS.GET_OEM_SCANS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SCAN_CONSTANTS.RESET_SCAN_STATE:
      return initialState;
    default:
      return state;
  }
};

export default scanReducer;